import { render } from "./ToTopButton.vue?vue&type=template&id=690e2bfc&scoped=true"
import script from "./ToTopButton.vue?vue&type=script&lang=js"
export * from "./ToTopButton.vue?vue&type=script&lang=js"

import "./ToTopButton.vue?vue&type=style&index=0&id=690e2bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690e2bfc"]])

export default __exports__